import { Briefcase, Plane, Code2, Users, Building2, GraduationCap } from "lucide-react";

const USE_CASES = [
  { icon: Code2, title: "Tech bros & sis", body: "Receive payment for remote work and cash out instantly to your Nigerian account." },
  { icon: Briefcase, title: "Crypto traders", body: "Convert profits across BTC, ETH, USDT and more — at the rates you actually deserve." },
  { icon: Plane, title: "Frequent travellers", body: "Move your money before you move yourself. Funds available the moment you land." },
  { icon: Users, title: "Family & loved ones", body: "Send funds home faster and cheaper than any traditional remittance service." },
  { icon: Building2, title: "Business owners", body: "Pay international staff, suppliers and vendors — settle quickly without bank delays." },
  { icon: GraduationCap, title: "Students abroad", body: "Receive upkeep from home in any crypto and convert to naira as you need it." },
];

export default function UseCases() {
  return (
    <section className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-testid="use-cases-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
            Built for everyone
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-slate-900" data-testid="use-cases-title">
            Whoever moves money,
            <br /> moves it with PamaPay.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {USE_CASES.map((u, i) => {
            const Icon = u.icon;
            return (
              <div
                key={u.title}
                className="rounded-2xl border border-slate-200 bg-white p-6 hover:border-[#3B6FBF]/40 hover:shadow-[0_8px_30px_-10px_rgba(59,111,191,0.2)] transition-all duration-300"
                data-testid={`use-case-card-${i}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-[#3B6FBF]/10 border border-[#3B6FBF]/20 flex items-center justify-center text-[#3B6FBF] flex-shrink-0">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-lg mb-1 text-slate-900">{u.title}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">{u.body}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
